import { useMemo } from "react"

import {
  selectIsConnected,
  selectLatestBridgeTransactions,
  useDappSelector,
} from "#/redux-state"
import { useAccountHistory } from "#/shared/hooks"

import OverviewBridgeTransactionItem from "./OverviewBridgeTransactionItem"
import OverviewSection from "./OverviewSection"
import OverviewSwapTransactionItem from "./OverviewSwapTransactionItem"

export default function OverviewLatestTransactions() {
  const isConnected = useDappSelector(selectIsConnected)

  const { data: accountHistory, isLoading } = useAccountHistory()

  const latestBridgeTransactions = useDappSelector(
    selectLatestBridgeTransactions,
  )

  const accountHistoryToDisplay = useMemo(() => {
    if (!accountHistory && !latestBridgeTransactions.length) {
      return []
    }

    const fetchedAccountHistory = accountHistory ?? []

    const uniqueTransactions = Array.from(
      new Map(
        [...fetchedAccountHistory, ...latestBridgeTransactions].map((item) => [
          item.transactionHash,
          item,
        ]),
      ).values(),
    )

    return uniqueTransactions
      .sort((a, b) => b.timestamp - a.timestamp)
      .slice(0, 5)
  }, [accountHistory, latestBridgeTransactions])

  if (!isConnected || (!accountHistoryToDisplay.length && !isLoading))
    return null

  return (
    <OverviewSection header="Latest Transactions" isLoading={isLoading}>
      {accountHistoryToDisplay.map(
        ({ timestamp, transactionHash, type, metadata }) => {
          if (type === "swap") {
            return (
              <OverviewSwapTransactionItem
                key={transactionHash}
                timestamp={timestamp}
                transactionHash={transactionHash}
                fromToken={metadata.fromToken}
                toToken={metadata.toToken}
                toAmount={metadata.toAmount}
              />
            )
          }

          if (type === "bridge") {
            return (
              <OverviewBridgeTransactionItem
                key={transactionHash}
                amount={metadata.amount}
                token={metadata.token}
                transactionHash={transactionHash}
              />
            )
          }

          return null
        },
      )}
    </OverviewSection>
  )
}
